import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { types as sdkTypes } from '../../util/sdkLoader';
import { formatMoney } from '../../util/currency';
import { Heading } from '../../components';

import css from './ListingPage.module.css';

const { Money } = sdkTypes;

const REGION_LABEL_IDS = {
  national: 'EditListingDeliveryForm.shippingRegionNational',
  continental: 'EditListingDeliveryForm.shippingRegionContinental',
  global: 'EditListingDeliveryForm.shippingRegionGlobal',
};

const REGIONS = ['national', 'continental', 'global'];

const SectionShippingPricesMaybe = props => {
  const { publicData, currency, isMarkedSold, isOwnListing, intl } = props;

  if (!isOwnListing || !isMarkedSold || !currency) return null;

  const shippingPrices = publicData?.shippingPrices;
  if (!shippingPrices) return null;

  const visibleRegions = REGIONS.filter(region => {
    const prices = shippingPrices[region];
    return prices && (prices.oneItem != null || prices.additionalItems != null);
  });

  if (visibleRegions.length === 0) return null;

  const formatSubunits = subunits => {
    if (subunits == null) return null;
    try {
      return formatMoney(intl, new Money(subunits, currency));
    } catch (e) {
      return null;
    }
  };

  return (
    <section className={css.sectionShippingPrices}>
      <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
        <FormattedMessage id="ListingPage.shippingPricesTitle" />
      </Heading>
      <ul className={css.shippingPricesList}>
        {visibleRegions.map(region => {
          const prices = shippingPrices[region];
          return (
            <li key={region} className={css.shippingPricesItem}>
              <div className={css.shippingPricesRegion}>
                <FormattedMessage id={REGION_LABEL_IDS[region]} />
              </div>
              {prices.oneItem != null ? (
                <div>
                  <FormattedMessage
                    id="ListingPage.shippingOneItem"
                    values={{ price: formatSubunits(prices.oneItem) }}
                  />
                </div>
              ) : null}
              {prices.additionalItems != null ? (
                <div>
                  <FormattedMessage
                    id="ListingPage.shippingAdditionalItems"
                    values={{ price: formatSubunits(prices.additionalItems) }}
                  />
                </div>
              ) : null}
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default SectionShippingPricesMaybe;
